// http://vuex.vuejs.org/en/getters.html
import { isEmpty } from 'lodash';

// if has token, we assume that user is logged in our system
const isLogged = ({ user }) => !isEmpty(user);

// get current user data
const currentUser = ({ user }) => user;

export default {
  isLogged,
  currentUser
}



// WEBPACK FOOTER //
// ./src/pages/auth/store/getters.js